import React from 'react';
import { useCopyDropOverlayGeometry, useCopyDropOverlayIsActive } from '../../stores/CopyDropOverlayStore';
import {
    NOTE_HEIGHT,
    NOTE_WIDTH,
    tickToPosition
} from '../../render/renderUtils';
import { SelectionGeometry } from '../../utils/NoteSelectionGroup';
import { NoteRangeType } from '../../model/containers';
import { useZoomFactor } from '../../stores/ZoomStore';

// FIXME
const PIANOROLL_HEADER__WIDTH = 32;

export function CopyDropOverlay({
    noteRange
}: {
    noteRange: NoteRangeType
}) {

    const geometry = useCopyDropOverlayGeometry();
    const isActive = useCopyDropOverlayIsActive();
    const zoomFactor = useZoomFactor();

    if (!geometry || !isActive) return null;
    const { left, top, width, height, start, topNote } = geometry;

    const style: React.CSSProperties = {
        position: 'absolute',
        left: `${(tickToPosition(NOTE_WIDTH, zoomFactor, start) + PIANOROLL_HEADER__WIDTH)}px`,
        top: `${(106 - topNote + (noteRange.max - 107)) * NOTE_HEIGHT}px`,
        // FIXME: something upstream needs to be changed to width in ticks. We hack this by doings this
        // ugly "width / NOTE_WIDTH"
        width: `${tickToPosition(NOTE_WIDTH, zoomFactor, width / NOTE_WIDTH)}px`,
        height: `${height}px`,
        backgroundColor: 'rgba(255, 0, 0, 0.2)',
        borderRadius: '2px',
        pointerEvents: 'none',
    };

    return (<div style={style} />);
}

export function SelectedRegionOverlay({
    geometry,
    noteRange,
}: {
    geometry?: SelectionGeometry,
    noteRange: NoteRangeType,
}) {
    const zoomFactor = useZoomFactor();

    if (!geometry) return null;

    const style: React.CSSProperties = {
        position: 'absolute',
        left: `${(tickToPosition(NOTE_WIDTH, zoomFactor, geometry.left) + PIANOROLL_HEADER__WIDTH)}px`,
        top: `${(106 - geometry.top - (107 - noteRange.max)) * NOTE_HEIGHT}px`,
        width: `${tickToPosition(NOTE_WIDTH, zoomFactor, geometry.width)}px`,
        height: `${geometry.height * NOTE_HEIGHT}px`,
        backgroundColor: 'rgba(0, 255, 0, 0.2)',
        borderRadius: '2px',
        pointerEvents: 'none',
    };

    return (<div style={style} />);
}